// iOS app page (/app/): the same animated alchemist as the main landing hero, and nothing
// else - no leaderboard fetch, no card grids, no analytics on this page.

import { spriteToCanvas } from './render/pixelArt';

// Animated alchemist above the title: runs in place (frame swap + bob) and leans/turns
// toward the mouse, identical to the homepage hero.
function heroCharacter(): void {
  const canvas = document.getElementById('heroChar') as HTMLCanvasElement | null;
  if (canvas === null) return;
  const frames = ['playerA', 'playerB'].map((k) => spriteToCanvas(k, 1)); // native pixels
  const CHAR_W = 60; // displayed character width
  const CHAR_H = Math.round((CHAR_W * frames[0].height) / frames[0].width);
  const padX = 22; // room to lean sideways
  const padY = 8; // room to bob
  canvas.width = CHAR_W + padX * 2;
  canvas.height = CHAR_H + padY;
  const ctx = canvas.getContext('2d');
  if (ctx === null) return;
  ctx.imageSmoothingEnabled = false;

  let mouseX = window.innerWidth / 2;
  window.addEventListener('mousemove', (e) => {
    mouseX = e.clientX;
  });

  let t = 0;
  const step = (): void => {
    t += 1;
    const f = frames[Math.floor(t / 8) % frames.length]; // ~7.5fps run cadence
    const bob = Math.abs(Math.sin(t * 0.16)) * padY;
    const rect = canvas.getBoundingClientRect();
    const cx = rect.left + rect.width / 2;
    const lean = Math.max(-padX, Math.min(padX, (mouseX - cx) / 22));
    ctx.clearRect(0, 0, canvas.width, canvas.height);
    ctx.save();
    ctx.translate(canvas.width / 2 + lean, padY - bob);
    if (mouseX < cx) ctx.scale(-1, 1); // face the cursor
    ctx.drawImage(f, -CHAR_W / 2, 0, CHAR_W, CHAR_H);
    ctx.restore();
    requestAnimationFrame(step);
  };
  step();
}

heroCharacter();
